import { createFileRoute } from '@tanstack/react-router';
import { DashboardPage } from '@/features/client/dashboard';
import { clientGuard } from '@/lib/route-guards';

export const Route = createFileRoute('/client/')({
  beforeLoad: clientGuard,
  component: ClientIndexRoute,
});

function ClientIndexRoute() {
  return <DashboardPage />;
}
